import React from "react";
import { Container, Image, H3, ADImage } from "../../style/Header";
import Photo from "../../assets/demo.jpg";
import { CustomDiv } from "../../style/shared";
import { subject } from "../../service";
import AdvertiserCard from "../common/card";

import MedizenCreative from "../NewCreatives/MedizenCreative/MedizenCreative";
import Mycontext from "../../store/Mycontext";
import { NEW_AD_CREATIVE, NEW_CREATIVE_LOCATION, creativeConstants, htmls } from "../../constants";
import CustomBannerImage from "../../assets/Ads/vertical.jpeg";
import { Grid } from "@material-ui/core";

export class Header extends React.Component {
  imgsrc = "Ads/Horizontal1.jpeg";

  constructor(props) {
    super(props);
    this.adConfig = localStorage.getItem("creativeConfig") ? JSON.parse(localStorage.getItem("creativeConfig")) : null;
  }

  componentDidMount() {
    this.subscription = subject.subscribe((res) => {
      this.imgsrc = res.headerImg;
      this.useImgSrc = res.useThis;
      this.forceUpdate();
    });
  }

  componentWillUnmunt() {
    this.subscription.unsubscribe();
  }

  getDrugToShowDashboard = () => {
    const locAdConfig = localStorage.getItem("creativeConfig") ? JSON.parse(localStorage.getItem("creativeConfig")) : null;
    if (!locAdConfig) return;
    const withCta = locAdConfig ? locAdConfig.creative_cta === "With CTAs" : null;

    // check all present 
    const allPresent = creativeConstants.messaging_sparks.every((element) => locAdConfig.messaging_sparks.includes(element));
    if (allPresent) {
      // const newRandValue = Math.floor(Math.random() * 2);
      // if (newRandValue === 1) return withCta ? NEW_AD_CREATIVE.PAINFIN : NEW_AD_CREATIVE.PAINFIN_NO_CTA;
      return withCta ? NEW_AD_CREATIVE.PAINFIN : NEW_AD_CREATIVE.PAINFIN_NO_CTA;
    }

    // if any of rep or sample and copay
    const isSecond = ['Rep', 'Copay'].every((element) => locAdConfig.messaging_sparks.includes(element)) || ['Sample', 'Copay'].every((element) => locAdConfig.messaging_sparks.includes(element));
    if (isSecond) return withCta ? NEW_AD_CREATIVE.PAINFIN : NEW_AD_CREATIVE.PAINFIN_NO_CTA;

    // if drug, trail and copay all 3 present
    const isThird = ['Drug', 'Trial', 'Copay'].every((element) => locAdConfig.messaging_sparks.includes(element));
    if (isThird) return withCta ? NEW_AD_CREATIVE.PSORIASIS_TRAIL : NEW_AD_CREATIVE.PSORIASIS_TRAIL_NO_CTA;

    // if only clinical and copay
    const isFourth = ['Drug', 'Copay'].every((element) => locAdConfig.messaging_sparks.includes(element));
    if (isFourth) return withCta ? NEW_AD_CREATIVE.CARE_DURA : NEW_AD_CREATIVE.CARE_DURA_NO_CTA

    if(locAdConfig.messaging_sparks.includes('Drug'))  return withCta ? NEW_AD_CREATIVE.CARE_DURA : NEW_AD_CREATIVE.CARE_DURA_NO_CTA

    return withCta ? NEW_AD_CREATIVE.PSORIASIS_TRAIL : NEW_AD_CREATIVE.PSORIASIS_TRAIL_NO_CTA;
  }

  getDrugToShowConsultation = () => {
    const locAdConfig = localStorage.getItem("creativeConfig") ? JSON.parse(localStorage.getItem("creativeConfig")) : null;
    if (!locAdConfig) return;
    const withCta = locAdConfig ? locAdConfig.creative_cta === "With CTAs" : null;

    // check all present 
    const allPresent = creativeConstants.messaging_sparks.every((element) => locAdConfig.messaging_sparks.includes(element));
    if (allPresent) return withCta ? NEW_AD_CREATIVE.PAINFIN : NEW_AD_CREATIVE.PAINFIN_NO_CTA;

    // if any of rep or sample and copay
    const isSecond = ['Rep', 'Copay'].every((element) => locAdConfig.messaging_sparks.includes(element)) || ['Sample', 'Copay'].every((element) => locAdConfig.messaging_sparks.includes(element));
    if (isSecond) return withCta ? NEW_AD_CREATIVE.PAINFIN : NEW_AD_CREATIVE.PAINFIN_NO_CTA;

    // if drug, trail and copay all 3 present
    const isThird = ['Drug', 'Trial', 'Copay'].every((element) => locAdConfig.messaging_sparks.includes(element));
    if (isThird) return withCta ? NEW_AD_CREATIVE.PSORIASIS_TRAIL : NEW_AD_CREATIVE.PSORIASIS_TRAIL_NO_CTA;

    // if only clinical and copay
    const isFourth = ['Drug', 'Copay'].every((element) => locAdConfig.messaging_sparks.includes(element));
    if (isFourth) return withCta ? NEW_AD_CREATIVE.CARE_DURA : NEW_AD_CREATIVE.CARE_DURA_NO_CTA

    return withCta ? NEW_AD_CREATIVE.PAINFIN : NEW_AD_CREATIVE.PAINFIN_NO_CTA;
  }


  static contextType = Mycontext;
  render() {
    const { CustomBanner, location, selectedBanner } = this.props;
    const randValue = parseInt(window.sessionStorage.getItem("rValue"));
    const getRandomHoriCreative = () => {
      if (location.pathname === "/People/dashboard" || (location.pathname === '/People/Consultation' && selectedBanner === 'new_banners') || randValue == 0) {
        return NEW_CREATIVE_LOCATION[location.pathname === '/People/dashboard' ? this.getDrugToShowDashboard() : this.getDrugToShowConsultation()].horizontal;      }

      const withCta = this.adConfig.creative_cta === "With CTAs";
      if (!this.adConfig) return;

      if (withCta) {
        if (randValue === 1) {
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.MedizenHoriAddWithCTARep;
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.MedizenHoriAddWithCTASample;
          return htmls.MedizenHoriAddWithCta;
        }
        if (randValue === 2) {
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.PrimeraHoriAddWithCTARep;
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.PrimeraHoriAddWithCTASample;
          return htmls.PrimeraHoriAddWithCTA;
        }
        if (randValue === 3) {
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.PanazHoriAddWithCTASample;
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.PanazHoriAddWithCTARep;
          return htmls.PanazHoriAddWithCta;
        }
      } else {
        if (randValue === 1) {
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.MedizenHoriAddWithoutCTASample;
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.MedizenHoriAddWithoutCTARep;
          return htmls.MedizenHoriAddWithoutCTA;
        }
        if (randValue === 2) {
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.PrimeraHoriAddWithoutCTARep;
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.PrimeraHoriAddWithoutCTASample;
          return htmls.PrimeraHoriAddWithoutCTA;
        }
        if (randValue === 3) {
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.PanazHoriAddWithoutCTASample;
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.PanazHoriAddWithoutCTARep;
          return htmls.PanazHoriAddWithoutCTA;
        }
      }
    };

    return (
      <>
        <Grid container style={{alignItems:"center"}}>
          <Grid item md={`${CustomBanner ? "4" : "12"}`} xs={12} sm={12} className="d-flex headerSection ">
            <Image src={Photo} alt="photo" className="smResponsive Text-center" />
            <CustomDiv width="calc(100% - 115px)" className="smResponsive Text-center">
              <H3 style={{ marginTop: "2px" }}>
                Patient : <span style={{ color: "#4678ED" }}>Phil Belford</span>{" "}
              </H3>
              <H3>DOB : 1972-02-09 </H3>
              <H3>Age : 49</H3>
            </CustomDiv>
          </Grid>
          {
            CustomBanner &&
            <Grid item md={8} xs={12} sm={12}>
              {
                <div className="responsiveMargin" style={{ maxWidth: '728px', maxHeight: '90px', }}>
                <iframe
                  title="iframe"
                  srcDoc={CustomBanner ? getRandomHoriCreative() : null}
                  style={{
                    width: '100%',
                    height: '100%',
                    maxWidth: '728px',
                    maxHeight: '90px'
                  }}
                  frameBorder="0"
                  scrolling="no"
                />
              </div>
                
              }
            </Grid>
          }

        </Grid>
      </>
    );
  }
}
